import "./Loading.css";


function Loading() {
    return (
        <div className="containerLoading">
            <div className="loading">
                <div className="lds-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <img className="gifLoading" src={`${process.env.PUBLIC_URL}/img/Yuri2.gif`} alt="Yuri" />
                <h2>Loading...</h2>
            </div>
        </div>
    );
}

export default Loading;
